// Greys out colour swatches when the selected size isn't available in that colour.
(function() {
  'use strict';

  // handle -> Promise<Array<variant>>
  const variantCache = new Map();

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function handleFromHref(href) {
    if (!href) return null;
    const afterProducts = href.split('/products/')[1];
    if (!afterProducts) return null;
    return afterProducts.split('?')[0].split('#')[0].split('/')[0];
  }

  function fetchVariants(handle) {
    if (variantCache.has(handle)) return variantCache.get(handle);
    const promise = fetch(rootUrl() + 'products/' + handle + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(product) { return (product && product.variants) || []; })
      .catch(function() { return []; });
    variantCache.set(handle, promise);
    return promise;
  }

  // Colour swatches that link to a separate sibling product (combined listing)
  function getCombinedSwatches(variantPicker) {
    return Array.from(variantPicker.querySelectorAll(
      'a.color-swatch[href*="/products/"], a.block-swatch[href*="/products/"], a.thumbnail-swatch[href*="/products/"]'
    ));
  }

  // Whatever size (or other non-colour option) the user has selected
  function getSelectedRealOptions(variantPicker) {
    const selected = [];
    variantPicker.querySelectorAll('fieldset').forEach(function(fieldset) {
      if (fieldset.querySelector('a[href*="/products/"]')) return;
      const checked = fieldset.querySelector('input[data-option-name]:checked');
      if (checked) selected.push(checked.getAttribute('data-option-name'));
    });
    return selected;
  }

  // Combined listings — fetch each sibling product and check if the selected size exists there
  function applyCombined(variantPicker) {
    const swatches = getCombinedSwatches(variantPicker);
    if (swatches.length === 0) return;

    const selectedOptions = getSelectedRealOptions(variantPicker);
    if (selectedOptions.length === 0) return;

    swatches.forEach(function(swatch) {
      const handle = handleFromHref(swatch.getAttribute('href'));
      if (!handle) return;

      fetchVariants(handle).then(function(variants) {
        const available = variants.some(function(v) {
          if (!v.available) return false;
          const opts = [v.option1, v.option2, v.option3].filter(Boolean);
          return selectedOptions.every(function(sel) { return opts.indexOf(sel) !== -1; });
        });
        swatch.classList.toggle('is-size-unavailable', !available);
      });
    });
  }

  // Regular products — colour and size are options on the same product
  function applyRegular(variantPicker) {
    const handle = variantPicker.getAttribute('handle');
    if (!handle) return;

    const checked = {};
    variantPicker.querySelectorAll('input[data-option-position]:checked').forEach(function(input) {
      checked[input.getAttribute('data-option-position')] = input.getAttribute('data-option-name');
    });
    if (Object.keys(checked).length < 2) return;

    variantPicker.querySelectorAll('fieldset').forEach(function(fieldset) {
      if (fieldset.querySelector('a[href*="/products/"]')) return;
      if (!fieldset.querySelector('label.color-swatch')) return;

      const inputs = Array.from(fieldset.querySelectorAll('input[data-option-position]'));
      if (inputs.length === 0) return;
      const position = inputs[0].getAttribute('data-option-position');

      fetchVariants(handle).then(function(variants) {
        inputs.forEach(function(input) {
          const valueName = input.getAttribute('data-option-name');
          const available = variants.some(function(v) {
            if (!v.available) return false;
            const opts = [v.option1, v.option2, v.option3];
            if (opts[position - 1] !== valueName) return false;
            for (const pos in checked) {
              if (pos === position) continue;
              if (opts[pos - 1] !== checked[pos]) return false;
            }
            return true;
          });
          const label = fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]') || input.nextElementSibling;
          if (label) label.classList.toggle('is-size-unavailable', !available);
        });
      });
    });
  }

  function applyAvailability(variantPicker) {
    applyCombined(variantPicker);
    applyRegular(variantPicker);
  }

  function applyAll(root) {
    (root || document).querySelectorAll('variant-picker').forEach(applyAvailability);
  }

  document.addEventListener('DOMContentLoaded', function() { applyAll(); });

  // Re-apply after a variant change — the picker re-renders and wipes our classes
  document.addEventListener('variant:change', function(event) {
    const formId = event.detail && event.detail.formId && event.detail.formId.value;
    const variantPicker = formId
      ? document.querySelector('variant-picker[form-id="' + formId + '"]')
      : null;
    setTimeout(function() {
      if (variantPicker) applyAvailability(variantPicker);
      else applyAll();
    }, 150);
  });

  // Quick-buy modals get their own picker when opened
  document.addEventListener('dialog:after-show', function(event) {
    if (event.target.matches && event.target.matches('quick-buy-modal')) {
      setTimeout(function() { applyAll(event.target); }, 150);
    }
  }, true);
})();
